
import { GetUserNumberResponse } from './types';

const formatUserNumberResponse = (data: any) => ({
  usercount: data.usercount,
  syndicatecount: data.syndicatecount,
});

export default formatUserNumberResponse;
